// To convert csv to array, use https://www.convertcsv.com/csv-to-json.htm and this output template: ['{f1}','{f2}',{(f3)==""?"null":f3},'{f4}','{f5}','{f6}','{f7}','{f8}','{f9}','{f10}','{f11}']

import { Course } from '@/data/models'
import highSchoolCourses from '@/data/highSchoolCourses'

export const coursesListSource: [
  string,
  string,
  number,
  string,
  string,
  string,
  string,
  string,
  string | number,
  string | number,
  string | boolean,
][] = [
  ['ID-F001', '', 140, 'Engelsk', '', '', '', 'Felles', '', '', ''],
  ['ID-F001a', '', 84, 'Engelsk vg1', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F002', '', 225, 'Fremmedspråk', '', '', '', 'Felles', '', '', ''],
  ['ID-F003', '', 56, 'Geografi', '', '', '', 'Felles', '', '', ''],
  ['ID-F004', '', 169, 'Historie Vg2/Vg3', '', '', '', 'Felles', '', '', ''],
  ['ID-F004b', '', 140, 'Historie påbygg', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F005', '', 168, 'Kroppsøving', '', '', '', 'Felles', '', '', ''],
  ['ID-F006', '', 224, 'Matematikk', '', '', '', 'Felles', '', '', ''],
  [
    'ID-F006a',
    '',
    140,
    'Matematikk 1p / 1t',
    '',
    '',
    '',
    'FellesYF',
    '',
    '',
    '',
  ],
  ['ID-F006b', '', 84, 'Matematikk 2p', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F006c', '', 84, 'Matematikk 1p-y', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F006d', '', 140, 'Matematikk 2p-y', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F007', '', 140, 'Naturfag', '', '', '', 'Felles', '', '', ''],
  ['ID-F007a', '', 56, 'Naturfag yrkesfag', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F007b', '', 84, 'Naturfag påbygg', '', '', '', 'FellesYF', '', '', ''],
  ['ID-F008', '', 393, 'Norsk hovedmål', '', '', '', 'Felles', '', '', ''],
  ['ID-F008a', '', 0, 'Norsk sidemål', '', '', '', 'Felles', '', '', ''],
  ['ID-F008b', '', 0, 'Norsk muntlig', '', '', '', 'Felles', '', '', ''],
  ['ID-F009', '', 84, 'Religion og etikk', '', '', '', 'Felles', '', '', ''],
  ['ID-F010', '', 84, 'Samfunnskunnskap', '', '', '', 'Felles', '', '', ''],
  [
    'ID-P001',
    'Bio1',
    140,
    'Biologi 1',
    'ID-P002',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  [
    'ID-P002',
    'Bio2',
    140,
    'Biologi 2',
    'ID-P001',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  [
    'ID-P003',
    'Fys1',
    140,
    'Fysikk 1',
    'ID-P004',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  ['ID-P004', '', 140, 'Fysikk 2', 'ID-P003', '', '', 'SSReal', 1, '', ''],
  [
    'ID-P005',
    '',
    84,
    'Geofag X',
    '',
    'ID-P006',
    'Geofag 1',
    'SSReal',
    '',
    '',
    '',
  ],
  [
    'ID-P006',
    '',
    140,
    'Geofag 1',
    'ID-P007',
    'ID-P005',
    'Geofag X',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  ['ID-P007', '', 140, 'Geofag 2', 'ID-P006', '', '', 'SSReal', '0,5', '', ''],
  [
    'ID-P008',
    '',
    140,
    'Informasjonsteknologi 1',
    'ID-P009',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  [
    'ID-P009',
    '',
    140,
    'Informasjonsteknologi 2',
    'ID-P008',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  ['ID-P010', '', 140, 'Kjemi 1', 'ID-P011', '', '', 'SSReal', '0,5', '', ''],
  ['ID-P011', '', 140, 'Kjemi 2', 'ID-P010', '', '', 'SSReal', '0,5', '', ''],
  ['ID-P012', '', 84, 'Matematikk X', '', '', '', 'SSReal', '', '', ''],
  [
    'ID-P013',
    '',
    140,
    'Matematikk R1',
    'ID-P014',
    'ID-P015, ID-P016',
    'S1 eller S2',
    'SSReal',
    '0,5',
    '',
    true,
  ],
  [
    'ID-P014',
    '',
    140,
    'Matematikk R2',
    'ID-P013',
    'ID-P015, ID-P016',
    'S1 eller S2',
    'SSReal',
    1,
    '',
    true,
  ],
  [
    'ID-P015',
    '',
    140,
    'Matematikk S1',
    'ID-P016',
    'ID-P013, ID-P014',
    'R1 eller R1',
    'SSReal',
    '0,5',
    '',
    true,
  ],
  [
    'ID-P016',
    '',
    140,
    'Matematikk S2',
    'ID-P015',
    'ID-P013, ID-P014',
    'R1 eller R1',
    'SSReal',
    '0,5',
    '',
    true,
  ],
  [
    'ID-P017',
    '',
    84,
    'Teknologi og forskningslære X',
    '',
    'ID-P018',
    'Tek og forsk 1',
    'SSReal',
    '',
    '',
    '',
  ],
  [
    'ID-P018',
    '',
    140,
    'Teknologi og forskningslære 1',
    'ID-P019',
    'ID-P017',
    'Tek og forsk X',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  [
    'ID-P019',
    '',
    140,
    'Teknologi og forskningslære 2',
    'ID-P018',
    '',
    '',
    'SSReal',
    '0,5',
    '',
    '',
  ],
  ['ID-P020', '', 140, 'Antikkens kultur', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P021', '', 140, 'Gresk 1', 'ID-P022', '', '', 'SSSamf', '', '', ''],
  ['ID-P022', '', 140, 'Gresk 2', 'ID-P021', '', '', 'SSSamf', '', '', ''],
  ['ID-P023', '', 140, 'Latin 1', 'ID-P024', '', '', 'SSSamf', '', '', ''],
  ['ID-P024', '', 140, 'Latin 2', 'ID-P023', '', '', 'SSSamf', '', '', ''],
  ['ID-P025', '', 140, 'Engelsk 1', 'ID-P026', '', '', 'SSSamf', '', '', ''],
  ['ID-P026', '', 140, 'Engelsk 2', 'ID-P025', '', '', 'SSSamf', '', '', ''],
  [
    'ID-P027',
    '',
    140,
    'Engelskspråklig litteratur og kultur',
    'ID-P025',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P028',
    '',
    140,
    'Entreprenørskap og bedriftsutvikling 1',
    'ID-P029',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P029',
    '',
    140,
    'Entreprenørskap og bedriftsutvikling 2',
    'ID-P028',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P030',
    '',
    140,
    'Fremmedspråk I (fellesfag)',
    'ID-P031',
    '',
    '',
    'SSSamf',
    '',
    '0,5',
    '',
  ],
  [
    'ID-P031',
    '',
    140,
    'Fremmedspråk II (fellesfag)',
    'ID-P030',
    '',
    '',
    'SSSamf',
    '',
    '0,5',
    '',
  ],
  [
    'ID-P032',
    '',
    140,
    'Fremmedspråk III (fellesfag)',
    '',
    '',
    '',
    'SSSamf',
    '',
    1,
    '',
  ],
  [
    'ID-P033',
    '',
    140,
    'Historie og filosofi 1',
    'ID-P034',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P034',
    '',
    140,
    'Historie og filosofi 2',
    'ID-P033',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P035',
    '',
    140,
    'Kommunikasjon og kultur 1',
    'ID-P036',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P036',
    '',
    140,
    'Kommunikasjon og kultur 2',
    'ID-P035',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P037',
    '',
    140,
    'Kommunikasjon og kultur 3',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P038',
    '',
    140,
    'Markedsføring og ledelse 1',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P039',
    '',
    140,
    'Markedsføring og ledelse 2',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P040',
    '',
    140,
    'Medie- og informasjonskunnskap 1',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P041',
    '',
    140,
    'Medie- og informasjonskunnskap 2',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  ['ID-P042', '', 140, 'Økonomistyring', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P043', '', 140, 'Økonomi og ledelse', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P044', '', 140, 'Sosialkunnskap', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P045', '', 140, 'Samfunnsgeografi', '', '', '', 'SSSamf', '', '', ''],
  [
    'ID-P046',
    '',
    140,
    'Sosiologi og sosialantropologi',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P047',
    '',
    140,
    'Politikk og menneskerettigheter',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  ['ID-P048', '', 140, 'Psykologi 1', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P049', '', 140, 'Psykologi 2', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P050', '', 140, 'Reiseliv og språk 1', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P051', '', 140, 'Reiseliv og språk 2', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P052', '', 140, 'Rettslære 1', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P053', '', 140, 'Rettslære 2', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P054', '', 140, 'Samfunnsøkonomi 1', '', '', '', 'SSSamf', '', '', ''],
  ['ID-P055', '', 140, 'Samfunnsøkonomi 2', '', '', '', 'SSSamf', '', '', ''],
  [
    'ID-P056',
    '',
    140,
    'Samisk historie og samfunn 1',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  [
    'ID-P057',
    '',
    140,
    'Samisk historie og samfunn 2',
    '',
    '',
    '',
    'SSSamf',
    '',
    '',
    '',
  ],
  ['ID-P058', '', 140, 'Aktivitetslære 1', '', '', '', 'IFP', '', '', ''],
  ['ID-P059', '', 140, 'Aktivitetslære 2', '', '', '', 'IFP', '', '', ''],
  ['ID-P060', '', 140, 'Aktivitetslære 3', '', '', '', 'IFP', '', '', ''],
  ['ID-P061', '', 56, 'Idrett og samfunn Vg2', '', '', '', 'IFP', '', '', ''],
  ['ID-P062', '', 84, 'Idrett og samfunn Vg3', '', '', '', 'IFP', '', '', ''],
  ['ID-P063', '', 56, 'Treningsledelse 1', '', '', '', 'IFP', '', '', ''],
  ['ID-P064', '', 112, 'Treningsledelse 2 + 3', '', '', '', 'IFP', '', '', ''],
  ['ID-P065', '', 56, 'Treningslære 1-Vg1', '', '', '', 'IFP', '', '', ''],
  ['ID-P066', '', 84, 'Treningslære 1-Vg2', '', '', '', 'IFP', '', '', ''],
  ['ID-P067', '', 140, 'Treningslære 2', '', '', '', 'IFP', '', '', ''],
  ['ID-P068', '', 140, 'Breddeidrett 1', '', '', '', 'IVP', '', '', ''],
  ['ID-P069', '', 140, 'Breddeidrett 2', '', '', '', 'IVP', '', '', ''],
  ['ID-P070', '', 140, 'Breddeidrett 3', '', '', '', 'IVP', '', '', ''],
  ['ID-P071', '', 140, 'Friluftsliv 1', '', '', '', 'IVP', '', '', ''],
  ['ID-P072', '', 140, 'Friluftsliv 2', '', '', '', 'IVP', '', '', ''],
  ['ID-P073', '', 140, 'Lederutvikling 1', '', '', '', 'IVP', '', '', ''],
  ['ID-P074', '', 140, 'Lederutvikling 2', '', '', '', 'IVP', '', '', ''],
  ['ID-P075', '', 140, 'Toppidrett 1', '', '', '', 'IVP', '', '', ''],
  ['ID-P076', '', 140, 'Toppidrett 2', '', '', '', 'IVP', '', '', ''],
  ['ID-P077', '', 140, 'Toppidrett 3', '', '', '', 'IVP', '', '', ''],
  ['ID-P078', '', 140, 'Mediesamfunnet 1', '', '', '', 'MKFP', '', '', ''],
  ['ID-P079', '', 140, 'Mediesamfunnet 2', '', '', '', 'MKFP', '', '', ''],
  ['ID-P080', '', 140, 'Mediesamfunnet 3', '', '', '', 'MKFP', '', '', ''],
  ['ID-P081', '', 140, 'Medieuttrykk 1', '', '', '', 'MKFP', '', '', ''],
  ['ID-P082', '', 140, 'Medieuttrykk 2', '', '', '', 'MKFP', '', '', ''],
  ['ID-P083', '', 140, 'Medieuttrykk 3', '', '', '', 'MKFP', '', '', ''],
  ['ID-P084', '', 140, 'Bilde', '', '', '', 'MKVP', '', '', ''],
  ['ID-P085', '', 140, 'Grafisk design', '', '', '', 'MKVP', '', '', ''],
  ['ID-P086', '', 140, 'Lyddesign', '', '', '', 'MKVP', '', '', ''],
  ['ID-P087', '', 140, 'Tekst', '', '', '', 'MKVP', '', '', ''],
  ['ID-P088', '', 140, 'Medieutvikling', '', '', '', 'MKVP', '', '', ''],
  ['ID-P089', '', 140, 'Mediespesialisering', '', '', '', 'MKVP', '', '', ''],
  [
    'ID-P090',
    '',
    56,
    'Ergonomi og bevegelse 1',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P091',
    '',
    56,
    'Ergonomi og bevegelse 2',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P092',
    '',
    140,
    'Instruksjon og ledelse',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P093',
    '',
    140,
    'Instrument, kor, samspill 1',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P094',
    '',
    140,
    'Instrument, kor, samspill 2',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P095',
    '',
    140,
    'Musikk, dans og drama',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P096',
    '',
    140,
    'Musikk i perspektiv 1',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P097',
    '',
    140,
    'Musikk i perspektiv 2',
    '',
    '',
    '',
    'FPMusikk',
    '',
    '',
    '',
  ],
  ['ID-P098', '', 56, 'Bevegelse', '', '', '', 'VPMusikk', '', '', ''],
  ['ID-P099', '', 56, 'Lytting', '', '', '', 'VPMusikk', '', '', ''],
  ['ID-P100', '', 140, 'Musikk', '', '', '', 'VPMusikk', '', '', ''],
  [
    'ID-P101',
    '',
    140,
    'Musikk fordypning 1',
    '',
    '',
    '',
    'VPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P102',
    '',
    140,
    'Musikk fordypning 2',
    '',
    '',
    '',
    'VPMusikk',
    '',
    '',
    '',
  ],
  [
    'ID-P103',
    '',
    140,
    'Samisk musikk og scene',
    '',
    '',
    '',
    'VPMusikk',
    '',
    '',
    '',
  ],
  ['ID-P104', '', 140, 'Dans i perspektiv 1', '', '', '', 'FPDans', '', '', ''],
  ['ID-P105', '', 140, 'Dans i perspektiv 2', '', '', '', 'FPDans', '', '', ''],
  [
    'ID-P106',
    '',
    56,
    'Grunntrening i dans 1',
    '',
    '',
    '',
    'FPDans',
    '',
    '',
    '',
  ],
  [
    'ID-P107',
    '',
    56,
    'Grunntrening i dans 2',
    '',
    '',
    '',
    'FPDans',
    '',
    '',
    '',
  ],
  [
    'ID-P108',
    '',
    140,
    'Musikk, dans og drama',
    '',
    '',
    '',
    'FPDans',
    '',
    '',
    '',
  ],
  ['ID-P109', '', 140, 'Scenisk dans 1', '', '', '', 'FPDans', '', '', ''],
  ['ID-P110', '', 140, 'Scenisk dans 2', '', '', '', 'FPDans', '', '', ''],
  ['ID-P111', '', 140, 'Scenisk dans 3', '', '', '', 'FPDans', '', '', ''],
  ['ID-P112', '', 56, 'Bevegelse', '', '', '', 'VPDans', '', '', ''],
  ['ID-P113', '', 140, 'Danseteknikker', '', '', '', 'VPDans', '', '', ''],
  [
    'ID-P114',
    '',
    140,
    'Scenisk dans fordypning 1',
    '',
    '',
    '',
    'VPDans',
    '',
    '',
    '',
  ],
  [
    'ID-P115',
    '',
    140,
    'Scenisk dans fordypning 2',
    '',
    '',
    '',
    'VPDans',
    '',
    '',
    '',
  ],
  ['ID-P116', '', 140, 'Drama og samfunn', '', '', '', 'FPDrama', '', '', ''],
  [
    'ID-P117',
    '',
    140,
    'Musikk, dans og drama',
    '',
    '',
    '',
    'FPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P118',
    '',
    56,
    'Teater og bevegelse 1',
    '',
    '',
    '',
    'FPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P119',
    '',
    56,
    'Teater og bevegelse 2',
    '',
    '',
    '',
    'FPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P120',
    '',
    140,
    'Teater i perspektiv 1',
    '',
    '',
    '',
    'FPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P121',
    '',
    140,
    'Teater i perspektiv 2',
    '',
    '',
    '',
    'FPDrama',
    '',
    '',
    '',
  ],
  ['ID-P122', '', 140, 'Teaterproduksjon 1', '', '', '', 'FPDrama', '', '', ''],
  ['ID-P123', '', 140, 'Teaterproduksjon 2', '', '', '', 'FPDrama', '', '', ''],
  ['ID-P124', '', 56, 'Bevegelse', '', '', '', 'VPDrama', '', '', ''],
  [
    'ID-P125',
    '',
    140,
    'Samisk musikk og scene',
    '',
    '',
    '',
    'VPDrama',
    '',
    '',
    '',
  ],
  ['ID-P126', '', 140, 'Teaterensemble', '', '', '', 'VPDrama', '', '', ''],
  [
    'ID-P127',
    '',
    140,
    'Teaterproduksjon fordypning 1',
    '',
    '',
    '',
    'VPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P128',
    '',
    140,
    'Teaterproduksjon fordypning 2',
    '',
    '',
    '',
    'VPDrama',
    '',
    '',
    '',
  ],
  [
    'ID-P130',
    '',
    140,
    'Fremmedspråk I (programfag)',
    'ID-P031',
    '',
    '',
    'SSSamf',
    '',
    '0,5',
    '',
  ],
  [
    'ID-P131',
    '',
    140,
    'Fremmedspråk II (programfag)',
    'ID-P030',
    '',
    '',
    'SSSamf',
    '',
    '0,5',
    '',
  ],
  [
    'ID-P132',
    '',
    140,
    'Fremmedspråk III (programfag)',
    '',
    '',
    '',
    'SSSamf',
    '',
    1,
    '',
  ],
  [
    'ID-P133',
    '',
    197,
    'Helsefremmende arbeid (vg1)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P134',
    '',
    197,
    'Helsefremmende arbeid (vg2)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P135',
    '',
    140,
    'Kommunikasjon og samhandling (vg1)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P136',
    '',
    140,
    'Kommunikasjon og samhandling (vg2)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P137',
    '',
    140,
    'Yrkesliv i helse- og oppvekstfag',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P138',
    '',
    140,
    'Yrkesliv i helsearbeiderfag',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P139',
    '',
    169,
    'Yrkesfaglig fordypning (vg1)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P140',
    '',
    253,
    'Yrkesfaglig fordypning (vg2)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P141',
    '',
    197,
    'Elektroniske kretser og nettverk',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P142', '', 280, 'Energi- og styresystemer', '', '', '', '', '', '', ''],
  ['ID-P143', '', 337, 'Automatiseringssystemer', '', '', '', '', '', '', ''],
  ['ID-P144', '', 140, 'El-energisystemer', '', '', '', '', '', '', ''],
  [
    'ID-P145',
    '',
    197,
    'Data- og informasjonsteknologi',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P146',
    '',
    280,
    'Elektroniske kretser og utstyr',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P147', '', 140, 'Elektronisk kommunikasjon', '', '', '', '', '', '', ''],
  ['ID-P148', '', 337, 'Elenergi og styresystemer', '', '', '', '', '', '', ''],
  ['ID-P149', '', 197, 'Pedagogisk arbeid', '', '', '', '', '', '', ''],
  [
    'ID-P150',
    '',
    140,
    'Yrkesliv i barne- og ungdomsarbeiderfag',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P151', '', 197, 'Helse og sykdom', '', '', '', '', '', '', ''],
  [
    'ID-P152',
    '',
    140,
    'Yrkesliv i helseservicefag',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P153', '', 197, 'Ambulansemedisin', '', '', '', '', '', '', ''],
  ['ID-P154', '', 140, 'Yrkesliv i ambulansefag', '', '', '', '', '', '', ''],
  ['ID-P155', '', 197, 'Yrkesliv i hudpleiefag', '', '', '', '', '', '', ''],
  [
    'ID-P156',
    '',
    197,
    'Kommunikasjon, kunde og arbeidsliv',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P157',
    '',
    280,
    'Produktutvikling og produksjon',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P158', '', 290, 'Produksjon og arbeidsliv', '', '', '', '', '', '', ''],
  [
    'ID-P159',
    '',
    187,
    'Produktutvikling, bransjelære og kommunikasjon',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P160',
    '',
    220,
    'Hår, farge og strukturendring',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P161',
    '',
    257,
    'Kommunikasjon, klipp og frisyreforming',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P162',
    '',
    337,
    'Design, teknologi og produksjon',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P163', '', 140, 'Kunde og kommunikasjon', '', '', '', '', '', '', ''],
  [
    'ID-P164',
    '',
    159,
    'Konseptutvikling og programmering',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P165',
    '',
    159,
    'Produksjon og historiefortelling',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P166', '', 159, 'Teknologiforståelse', '', '', '', '', '', '', ''],
  ['ID-P167', '', 140, 'Brukerstøtte', '', '', '', '', '', '', ''],
  ['ID-P168', '', 169, 'Driftsstøtte', '', '', '', '', '', '', ''],
  ['ID-P169', '', 168, 'Utvikling', '', '', '', '', '', '', ''],
  ['ID-P170', '', 159, 'Design og visualisering', '', '', '', '', '', '', ''],
  [
    'ID-P171',
    '',
    159,
    'Konseptutvikling og kommunikasjon',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P172', '', 159, 'Teknologi og produksjon', '', '', '', '', '', '', ''],
  ['ID-P173', '', 169, 'Forretningsdrift (Vg1)', '', '', '', '', '', '', ''],
  ['ID-P174', '', 140, 'Kultur og samhandling', '', '', '', '', '', '', ''],
  [
    'ID-P175',
    '',
    168,
    'Markedsføring og innovasjon',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P176', '', 159, 'Forretningsdrift (Vg2)', '', '', '', '', '', '', ''],
  [
    'ID-P177',
    '',
    159,
    'Innovasjon og markedsføring',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P178', '', 159, 'Kultur og kommunikasjon', '', '', '', '', '', '', ''],
  [
    'ID-P179',
    '',
    168,
    'Administrasjon og bærekraftig drift',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ID-P180',
    '',
    140,
    'Kommunikasjon og yrkesutøvelse',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  ['ID-P181', '', 169, 'Sikkerhet', '', '', '', '', '', '', ''],
]

const twoExamCourses = [
  'ID-F001', // Engelsk
  'ID-P025', // Engelsk 1
  'ID-P026', // Engelsk 2
  'ID-P002', // Biologi 2
  'ID-P011', // Kjemi 2
  'ID-P004', // Fysikk 2
  'ID-P007', // Geofag 2
  'ID-F002', // Fremmedspråk
  'ID-P027', // Engelskspråklig litteratur og kultur
  'ID-P030', // Fremmedspråk I
  'ID-P031', // Fremmedspråk II
  'ID-P032', // Fremmedspråk III
  'ID-P130', // Fremmedspråk I (ekstra)
  'ID-P131', // Fremmedspråk II (ekstra)
  'ID-P132', // Fremmedspråk III (ekstra)
]

const starterCourses = [
  'ID-F001',
  'ID-F002',
  'ID-F003',
  'ID-F004',
  'ID-F005',
  'ID-F006a',
  'ID-F006b',
  'ID-F007',
  'ID-F008',
  'ID-F008a',
  'ID-F008b',
  'ID-F009',
  'ID-F010',
]

const all235courses = highSchoolCourses[235]

const coursesList = coursesListSource.map((course): Course => {
  let sciencepoints = course[8]
  const mathSciencepoints = course[10] ? course[10] : false
  let languagepoints = course[9]
  if (typeof sciencepoints === 'string') {
    sciencepoints = parseFloat(sciencepoints.replace(',', '.')) || 0
  }
  if (typeof languagepoints === 'string') {
    languagepoints = parseFloat(languagepoints.replace(',', '.')) || 0
  }

  return {
    id: course[0],
    name: course[3],
    hours: course[2],
    sciencepoints: sciencepoints,
    mathSciencepoints: mathSciencepoints,
    languagepoints: languagepoints,
    included: starterCourses.includes(course[0]),
    is235course: all235courses.includes(course[0]),
    grade: 0,
    exam: 0,
    exam2: 0,
    improved: 0,
    hadExam: false,
    numExams: 0,
    hasTwoExams: twoExamCourses.includes(course[0]),
    improved2: 0,
  }
})

export default coursesList
